import { useSelector, TypedUseSelectorHook } from "react-redux";
import reducers from "~/src/modules/MixedPallet/reducer";

export type RootState = ReturnType<typeof reducers>;

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
